import { render, staticRenderFns } from "./sks1.vue?vue&type=template&id=391c8fc2&scoped=true&"
import script from "./sks1.vue?vue&type=script&lang=js&"
export * from "./sks1.vue?vue&type=script&lang=js&"
import style0 from "./sks1.vue?vue&type=style&index=0&id=391c8fc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c8fc2",
  null
  
)

export default component.exports